// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__BqsgS"};